import type { QueryClientConfig } from '@tanstack/react-query';
import type { StatementType } from '@/lib/utils/cache-utils';

export const STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const GC_TIME = 10 * 60 * 1000; // 10 minutes

export const queryConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      gcTime: GC_TIME,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
};

// Helper to cleanup other statement types when switching tabs
export function cleanupOtherStatements(
  queryClient: any,
  currentType: StatementType,
  symbol: string,
) {
  const statementTypes: StatementType[] = [
    'income-statement',
    'balance-sheet',
    'cashflow-statement',
    'financial-growth',
  ];

  statementTypes
    .filter((type) => type !== currentType)
    .forEach((type) => {
      queryClient.removeQueries({
        queryKey: [type, symbol],
      });
    });
}

// Helper to check if data is fresh
export function isDataFresh(
  data: { date: string }[],
  maxAgeInDays = 90,
): boolean {
  if (!data || data.length === 0) return false;

  const latestDate = new Date(data[0].date);
  const now = new Date();
  const diffTime = now.getTime() - latestDate.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return diffDays <= maxAgeInDays;
}
